__turbopack_context__.v({
  "buttons": "faq-hero-module-scss-module__S8pPtW__buttons",
  "column": "faq-hero-module-scss-module__S8pPtW__column",
  "column-inner": "faq-hero-module-scss-module__S8pPtW__column-inner",
  "column-inner-": "faq-hero-module-scss-module__S8pPtW__column-inner-",
  "column-left": "faq-hero-module-scss-module__S8pPtW__column-left",
  "column-right": "faq-hero-module-scss-module__S8pPtW__column-right",
  "container": "faq-hero-module-scss-module__S8pPtW__container",
  "copy-column": "faq-hero-module-scss-module__S8pPtW__copy-column",
  "copy-container": "faq-hero-module-scss-module__S8pPtW__copy-container",
  "list-item": "faq-hero-module-scss-module__S8pPtW__list-item",
  "row": "faq-hero-module-scss-module__S8pPtW__row",
  "topic-container": "faq-hero-module-scss-module__S8pPtW__topic-container",
  "topic-list": "faq-hero-module-scss-module__S8pPtW__topic-list",
});
